import { ValidationErrors } from '@angular/forms';

/**
 * Checks that the coordinates are located in Germany
 */
export class DezimalgradGeokoordinatenValidator {

    public static readonly LONGITUDE_MIN = 5.866391;
    public static readonly LONGITUDE_MAX = 15.041755;

    public static readonly LATITUDE_MIN = 47.270186;
    public static readonly LATITUDE_MAX = 55.057858;

    public static readonly LONGITUDE_PATTERN = RegExp('^-?((\\d|[1-9]\\d|1[0-7]\\d)([.,]\\d+)?)|180([.,]0+)?$');
    public static readonly LATITUDE_PATTERN = RegExp('^-?([0-8]?\\d([.,]\\d+)?)|90([.,]0+)?$');

    static validateLongitude(value: any): ValidationErrors | null {
        return this.validate(value, this.LONGITUDE_MIN, this.LONGITUDE_MAX, this.LONGITUDE_PATTERN);
    }

    static validateLatitude(value: any): ValidationErrors | null {
        return this.validate(value, this.LATITUDE_MIN, this.LATITUDE_MAX, this.LATITUDE_PATTERN);
    }

    private static validate(value: any, min: number, max: number, coordinatePattern: RegExp): ValidationErrors | null {

        if (value === null || value === '' || !coordinatePattern.test(value)) {
            return { pattern: true };
        }

        value = '' + value;

        if (value.indexOf(',') > -1) {
            value = value.replace(',', '.');
        }

        if (!this.isNumeric(value)) {
            return { pattern: true };
        }

        if (+value < min || +value > max) {
            return { 'tnbGeoLongitudeInDeutschland': true };
        }

        return null;
    }

    private static isNumeric(val: any): val is number {
        return !this.isArray(val) && (val - parseFloat(val) + 1) >= 0;
    }

    private static isArray = Array.isArray || (<T>(x: any): x is T[] => x && typeof x.length === 'number');


}
